<template>
  <div class="tw-relative tw-flex tw-flex-col tw-gap-[12px]">
    <div v-if="title" class="tw-text-body-md-mobile apTablet2:tw-text-body-md-desktop" v-html="title" />
    <div>
      <textarea
        type="text"
        :class="[
          'tw-w-full',
          'tw-outline tw-outline-offset-[-2px] tw-outline-1 tw-outline-ap-gainsboro ',
          'focus:tw-outline-ap-dodger-blue focus:tw-outline-2',
          // ' dark:tw-bg-ap-nero dark:tw-outline-ap-night-rider dark:tw-text-white',
          'apDesktop:tw-rounded-xl tw-rounded-[10px] tw-bg-white tw-text-body-md-mobile apTablet2:tw-text-body-md-desktop tw-text-ap-nero ',
          'tw-px-6 tw-py-4'
        ]"
        :value="data"
        :rows="rows"
        :placeholder="placeholder"
        @input="updateData"
      />
    </div>
    <span
      v-if="errorMsg"
      :class="[
        'tw-text-body-md-mobile apTablet2:tw-text-body-md-desktop',
        'tw-absolute tw-bottom-[-36px] tw-right-0 tw-text-red-500 tw-z-50',
        'tw-transition-opacity tw-duration-300',
        { '!tw-opacity-0': errorMsg === '' }
      ]"
    >
      {{ errorMsg }}
    </span>
    <span
      v-else
      :class="[
        'tw-text-body-md-mobile apTablet2:tw-text-body-md-desktop',
        'tw-absolute tw-bottom-[-36px] tw-right-0 tw-text-ap-nobel tw-z-50',
        'tw-transition-opacity tw-duration-300',
        { '!tw-opacity-0': textCounter === '' }
      ]"
    >
      {{ textCounter }}
    </span>
  </div>
</template>

<script setup lang="ts">

import { computed } from 'vue';


const props = defineProps ({
  title: {
    type: String,
    required: false
  },
  data: {
    type: String,
    default: null
  },
  placeholder: String,
  rows: {
    type: Number,
    default: 3
  },
  maxTextCount: {
    type: Number,
    default: 250
  },
  minTextCount: {
    type: Number,
    default: 10,
  },
});

const wordCount = computed(() => {
  if (!props.data) return 0;
  // Split the text into words and filter out empty entries
  return props.data.trim().split(/\s+/).filter(Boolean).length;
});

const errorMsg = computed(() => {
  if (props.data) {
    const currentWordCount = wordCount.value;
    if (currentWordCount > props.maxTextCount) {
      return 'Maximum ' + props.maxTextCount + ' words';
    } else if (currentWordCount < props.minTextCount) {
      return 'Minimum ' + props.minTextCount + ' words';
    }
  }
  return '';
});

const textCounter = computed(() => {
  if (errorMsg.value === '') {
    const remainingWords = props.maxTextCount - wordCount.value;
    return remainingWords + ' words remaining';
  }
  return '';
});

const emit = defineEmits(['update:data']);

function updateData(event: Event) {
  emit('update:data',( event.target as HTMLInputElement).value);
}

</script>